import React from 'react';
import { Link } from 'react-router-dom';

const Register = () => {
    return (
        <div className="hero my-10 ">
        <div className="hero-content ">
         
          <div className="card  w-full  shadow-2xl">
            <h1 className="text-2xl font-semibold text-center mt-5">Sign Up</h1>
            <form className="card-body w-96">
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Full Name</span>
                </label>
                <input type="text" name='fullName' placeholder="Enter your Full Name" className="input input-bordered " />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Email</span>
                </label>
                <input type="email" name='email' placeholder="Enter your Email" className="input input-bordered " />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Password</span>
                </label>
                <input type="password" name='password' placeholder="Enter your Password" className="input input-bordered" />
                
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Confirm Password</span>
                </label>
                <input type="password" name='confirmPassword' placeholder="Enter your Confirm Password" className="input input-bordered" />
                <label className="label">
                  <a href="#!" className="label-text-alt link link-hover">Forgot password?</a>
                </label>
              </div>
              <div className="form-control mt-6">
                <button className="btn btn-accent text-white">Sign Up</button>
              </div>
              <p className='mt-2'>Already have an account ? <span className='text-primary '><Link to={'/login'} >Please Login</Link></span></p>
              <div className="divider">OR</div>
              <button className="btn btn-outline btn-accent uppercase text-white">Continue with google</button>
            </form>
          </div>
        </div>
      </div>
    );
};

export default Register;